
export function formatDate2 (date) {
  if (typeof date === 'number') {
    date = new Date(date * 1000)
  }
  const day = [date.getFullYear(), date.getMonth() + 1, date.getDate()]
  return `${day.join('/')}`
}

/**
 * 数组对象去重
 * @param {Array} arrData - 去重的数组
 * @param {string} key -去重的key
 * @returns {Array} - 去重之后的数组
 */
export const arrUnique = (arrData = [], key = 'id') => {
  const obj = {}
  return arrData.reduce((e, item) => {
    if (!obj[item[key]]) {
      obj[item[key]] = true
      e.push(item)
    }
    return e
  }, [])
}

/**
 *
 * @param {*} t  13位、10位时间戳 or 时间
 * @param {*} format yyyy-MM-dd hh:mm:ss.SSS
 * @returns
 */
export const formatDate = (t, format = 'yyyy-MM-dd hh:mm:ss.SSS') => {
  // 10位数时间戳处理
  if (typeof t === 'number' && `${t}`.length === 10) {
    t = t * 1000
  }

  t = new Date(t)
  const o = {
    'M+': t.getMonth() + 1,
    'd+': t.getDate(),
    'h+': t.getHours(),
    'm+': t.getMinutes(),
    's+': t.getSeconds(),
    'q+': Math.floor((t.getMonth() + 3) / 3),
    'S+': t.getMilliseconds(),
  }

  if (/(y+)/.test(format)) {
    format = format.replace(
      RegExp.$1,
      (t.getFullYear() + '').substr(4 - RegExp.$1.length)
    )
  }

  for (const k in o) {
    if (new RegExp('(' + k + ')').test(format)) {
      let formatStr = ''
      for (let i = 1; i <= RegExp.$1.length; i++) {
        formatStr += '0'
      }
      let replaceStr = ''
      if (RegExp.$1.length == 1) {
        replaceStr = o[k]
      } else {
        formatStr = formatStr + o[k]
        const index = ('' + o[k]).length
        formatStr = formatStr.substr(index)
        replaceStr = formatStr
      }
      format = format.replace(RegExp.$1, replaceStr)
    }
  }
  return format
}

/**
 * 发票时间格式转换
 */
export function formatDateFunc (date, formate = '/') {
  if (typeof date === 'number') {
    date = new Date(date * 1000)
  }
  const day = [date.getFullYear(), date.getMonth() + 1, date.getDate()]
  return `${day.join(formate)}`
}
